module.exports = __webpack_public_path__ + "static/media/that way again-01.7ef2bd25.png";